// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import VueAnalytics from "vue-analytics";
import "font-awesome/css/font-awesome.css";
import "digix-ui/ativos/sass/temas/habix.scss";

import "./estilos/estilos.scss";
import App from "./App";
import router from "./router";

import LocalStorage from "./plugins/localStorage";
import Api from "./plugins/api";
import Usuario from "./plugins/usuario";
import Moeda from "./plugins/moeda";
import Tempo from "./plugins/tempo";
import GerenciadorDeTermos from "./plugins/gerenciadorDeTermos";
import vueJquery from "vue-jquery";
import { inicializarSentry } from "./utils/lib/sentryInit";
import { inicializarClarity } from "./utils/lib/clarity";

inicializarSentry(Vue);
inicializarClarity();

Vue.config.productionTip = false;

Vue.use(LocalStorage);
Vue.use(Api);
Vue.use(Usuario);
Vue.use(Moeda);
Vue.use(Tempo);
Vue.use(GerenciadorDeTermos);
Vue.use(vueJquery);

if (process.env.NODE_ENV === "production") {
  Vue.use(VueAnalytics, {
    id: "UA-99794195-1",
    router,
  });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js